import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { storeName as layoutModelName } from 'store/models/layout.model';

import './styles.scss';

const Loading = () => {
  const loading = useSelector((state: RootState) => state[layoutModelName].loading);

  if (!loading) return null;

  return (
    <div className="click-account-loading__wrapper">
      <div className="loading__circle" />
      <div className="loading__logo con-logo_clik_60x68">
        <i className="icon-logo_clik_60x68">
          <span className="path1" />
          <span className="path2" />
        </i>
      </div>
    </div>
  );
};

export default React.memo(Loading);
